import { Actions } from './actions.js';
const actionProps = {
    onKeyphraseChange: Actions.KEYPHRASE_CHANGED,
    onClearFilters: Actions.CLEAR_FILTERS,
    onResultsPerPageChange: Actions.RESULTS_PER_PAGE_CHANGED,
    onPageNumberChange: Actions.PAGE_NUMBER_CHANGED,
    onItemClick: Actions.ITEM_CLICKED,
    onSortChange: Actions.SORT_CHANGED,
    onFacetClick: Actions.FACET_CLICKED,
    onFilterClick: Actions.FILTER_CLICKED,
};
export default actionProps;
